<template>
  <div>
  <Breadcrumbs main="Services" title="Budget Management" />
  <div v-if="loading" class="loader-12"></div>
  <div v-else class="container-fluid">
      <div class="row">
        <div class="col-xl-9 col-md-12 offset-xl-1 box-col-12">
          <div class="file-content">
            <div class="card">
              <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>Budget Management</h5>
                <span>Manage Budget</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                    <div>
                      <div class="row">
                        <div class="col-md-4 offset-md-2 offset-0">
                          <div class="form-group">
                            <label>Select Account</label>
                            <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-control" id="AccountNumber" name="AccountNumber" required="required"><option :value="form.accountNumber" disabled>{{form.accountNumber ? form.accountNumber : 'Select From Account *'}}</option>
                              <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="">Select Month</label>
                            <vue-monthly-picker :selectedBackgroundColor="'#E41617'" :clearOption="false" placeHolder="Select Date" @selected="getSelected" dateFormat="MM/YYYY" :monthLabels="monthsLabel" v-model="selectedMonth">
                            </vue-monthly-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="position: relative; height:100%; width:100%">
                      <pieChart :width="160" :height="160" :chartdata="data" v-if="loaded" :options="options"/>
                    </div>
                    <div class="budget-wrapper mt-4 d-flex justify-content-center" v-if="getBudget">
                      <div class="budget-card">
                        <span>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(getBudget.amount)}}</span>
                        <p>Total Budget</p>
                      </div>
                      <div class="budget-card ml-4">
                        <span>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(getBudget.totalExpense)}}</span>
                        <p>Total Expense</p>
                      </div>
                    </div>
                    <div class="budget-category-section">
                      <h5 class="text-center my-4" :class="updatedBudgetArray.length < 1 ? 'text-danger' : ''">{{updatedBudgetArray.length === 0 ? 'No budget available' : 'Your Budget'}}</h5>
                      <div class="row">
                        <div class="col-12 col-md-6" v-for="category in updatedBudgetArray" :key="category.id">
                          <div class="card shadow-sm ecommerce-widget" style="cursor:pointer;" :style="{'background':`#${category.color}40`}" @click="getBudgetDetails(category)" data-toggle="modal" data-target="#previewBudgetDetails">
                            <div class="card-body support-ticket-font">
                              <div class="row">
                                <div class="col-12 col-md-3 text-center">
                                  <div class="text-md-right d-flex justify-content-center">
                                    <radial-progress-bar :diameter="80"
                                        :completed-steps="category.percentageExpense"
                                        :total-steps="totalSteps"
                                        :stop-color="`#${category.color}`"
                                        :start-color="`#${category.color}`">
                                        <p>{{(category.percentageExpense).toFixed(0)}}%</p>
                                    </radial-progress-bar>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6">
                                  <h4 class="category-text text-md-left text-center">{{category.name}}</h4>
                                  <div class="d-flex justify-content-between">
                                      <div>
                                      <span class="text-dark">Budget</span>
                                      <p class="category-amount text-dark">₦{{category.amount.toLocaleString(2)}}</p>
                                    </div>
                                    <div>
                                      <span class="text-dark">Spent</span>
                                      <p class="category-amount text-dark">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(category.totalExpense)}}</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-3 d-none d-md-block">
                                  <div class="text-md-right icon-wrapper">
                                    <i class="fa fa-angle-right text-muted fa-2x" aria-hidden="true"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="budget-btn-section text-center my-4 row" v-if="updatedBudgetArray.length >= 1 && form.period === currentDate">
                          <div class="col-sm-12">
                              <button type="button" @click="deleteBudget(getBudget.id)" class="btn btn-primary mr-2">
                                <div v-if="loading">
                                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                </div>
                                <div v-else>
                                  <i class="fa fa-trash mr-2"></i>Delete Budget 
                                </div>
                              </button>
                              <button data-toggle="modal" data-target="#editModal" type="button" class="btn btn-warning ml-2"><i class="fa fa-pencil mr-2"></i>Edit Budget</button>
                          </div>
                        </div>
                        <div class="budget-btn-section text-center my-4 row" v-if="updatedBudgetArray.length < 1 && !isBudgetConfigured">
                          <div class="col-sm-12">
                            <router-link to="/budget/create-budget">
                              <button type="button" class="btn btn-danger ml-2"><i class="fa fa-plus mr-2"></i>Create Budget</button>
                            </router-link>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- preview budget details modal -->
    <div class="modal fade" id="previewBudgetDetails" tabindex="-1" role="dialog" aria-labelledby="previewBudgetDetailsTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pl-2" style="font-size: 20px">Budget Details</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card-content">
                            <div id="transactionDetailsBody" class="align-content-center align-items-center justify-content-center p-2">
                                <!-- Budget Details will be loaded here -->
                                <div class="budget-header-wrapper">
                                  <h5 class="text-center mb-4 text-dark">{{budgetDetails.name}}</h5>
                                  <div class="budget-icon text-center">
                                    <div class="icon-wrapper mb-3">
                                        <i :style="[{'background-color': `#${budgetDetails.color + '40'}`}, { 'color': `#${budgetDetails.color}`}]" class="icon" :class="budgetDetails.icon ? budgetDetails.icon : 'fa fa-database'"></i>
                                    </div>
                                    <p class="text-dark">{{budgetDetails.transactions.length === 0 ? 'No' : budgetDetails.transactions.length}} {{budgetDetails.transactions.length > 1 ? 'Transactions' : 'Transaction'}}</p>
                                    <span class="text-dark">Total Spending</span>
                                    <h5 class="mt-2 text-dark font-weight-bold">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(budgetDetails.totalExpense)}}</h5>
                                  </div>
                                </div>
                                <table class="table views-table table-striped">
                                  <tbody>
                                    <tr class="transaction-table" v-for="transaction in budgetDetails.transactions" :key="transaction.id">
                                      <td>Date <span class="font-weight-bold"><br>{{transaction.createdDate | moment}}</span></td>
                                      <td>Description<span class="font-weight-bold"><br>Transaction to {{transaction.label}}</span></td>
                                      <td>Amount<span class="font-weight-bold"><br>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(transaction.amount)}}</span></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- edit modal -->
    <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="editModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pl-2" style="font-size: 20px">Edit Budget</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                    <div class="row">
                        <div class="col-md-8 offset-0 offset-md-2 budget-card-1 mb-5">
                            <h5 class="total-budget-text">Total Budget</h5>
                            <h4 class="total-amount-text">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalAmount)}}</h4>
                        </div>
                        <div class="col-md-12" v-for="budget in updatedBudgetArray" :key="budget.id">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6">
                                    <div class="icon-wrapper mb-3 d-flex align-items-center">
                                        <i :class="budget.icon ? budget.icon : 'fa fa-database'" class="icon" :style="[{'color':`#${budget.color}`}, {'background-color':`#${budget.color + '40'}`}]"></i>
                                        <h6 class="ml-2 mt-2 text-dark">{{budget.name}}</h6>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <form>
                                        <div class="form-group">
                                          <input type="text" @paste.prevent v-model="budget.amount" @change="amountValue(budget)" @keypress="isNumber" @keyup="formatNum($event, budget.id)" class="form-control" placeholder="Enter Amount">
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <!-- system categories -->
                        <div class="col-md-12" v-for="systemCategory in updatedSystemCategories" :key="systemCategory.id">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6">
                                    <div class="icon-wrapper mb-3 d-flex align-items-center">
                                        <i :class="systemCategory.icon ? systemCategory.icon : 'fa fa-database'" class="icon" :style="[{'color':`#${systemCategory.color}`}, {'background-color':`#${systemCategory.color + '40'}`}]"></i>
                                        <h6 class="ml-2 mt-2 text-dark">{{systemCategory.name}}</h6>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <form>
                                        <div class="form-group">
                                          <input type="text" @paste.prevent v-model="systemCategory.amount" @change="getSystemValue(systemCategory)" @keypress="isNumber" @keyup="systemFormatNum($event, systemCategory.id)" class="form-control" placeholder="Enter Amount">
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 my-4 text-center">
                            <button data-toggle="modal" @click="addBudgetCategory" data-target="#addCategory" type="button" class="btn btn-outline-light ml-2"><i class="fa fa-plus mr-2"></i>Add New</button>
                        </div>
                        <div class="col-md-12 mt-2 mb-4 text-center">
                            <button @click="saveEditBudget" type="button" class="btn btn-danger btn-md ml-2">
                              <div v-if="loading">
                                <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                              </div>
                              <div v-else>Save Budget</div>
                            </button>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- add category modal -->
    <div class="modal fade" id="addCategory" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
                <h5 class="modal-title pl-2" style="font-size: 20px">Add Budget Category</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="text-dark">Category Name</label>
              <input type="text" v-model="newBudgetCategory.categoryName" class="form-control" placeholder="Enter Category Name">
            </div>
            <div class="form-group mb-4">
              <label class="text-dark">Select Color Tag</label>
              <div class="color-tag-wrapper d-flex justify-content-between">
                <div v-for="(color, index) in colorArray" :key="index" :class="[selectedIndex.includes(index) ? 'selected' : '']" class="circle" @click="getColor(color.color, index)" :style="{'background-color': `#${color.color}`}"></div>
              </div>
            </div>
            <div class="budget-btn-section text-center mt-5 my-4 row">
                <div class="col-sm-12">
                  <button @click="addNewBudgetCategory" type="button" class="btn btn-danger ml-2"><i class="fa fa-plus mr-2"></i>Add</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div v-else class="loader-12"></div> -->
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import pieChart from '../../components/pie.vue';
  import RadialProgressBar from 'vue-radial-progress';
  import VueMonthlyPicker from 'vue-monthly-picker';
  import moment from 'moment';
  import $ from 'jquery';
  import { decrypt } from '@/_services/encryption';
  export default {
    components: {
      pieChart,
      RadialProgressBar,
      VueMonthlyPicker,
    },
    filters: {
      moment: function (date) {
        return moment(date).format('Do MMMM, YYYY');
      }
    },
    data:() => ({
      format: 'yyyy-MM-dd',
      form: {
        accountNumber: null,
        period: null,
        platform: 1,
      },
      formData: {
        categories:[],
        platform: 1,
        shouldRollOver: true,
      },
      budgetDetails: {
        name: null,
        amount: null,
        color: null,
        category: null,
        totalExpense: null,
        transactions: [],
        icon: null,
      },
      newBudgetCategory: {
        categoryName: '',
        color: '',
      },
      selectedIndex: [],
      colorArray: [
        { id: 1, color: 'FF0304' }, 
        { id: 2, color:'FF2400' },
        { id: 3, color:'FF540b' },  
        { id: 4, color:'FF3a86' }, 
        { id: 5, color: 'FFffbe' }, 
        { id: 6, color: 'FFff0a' }, 
        { id: 7, color:'FF8ac9' }, 
        { id: 8, color:'FF0004' }, 
        { id: 9, color: 'FF4509' }
      ],
      totalAmount: '0.00',
      loaded: false,
      loading: false,
      completedSteps: 40,
      totalSteps: 100,
      selectedMonth: '',
      monthsLabel: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      data: {
        labels: [
          'Total Budget',
          'Total Expense',
        ],
        datasets: [{
          label: 'Budget',
          data: [],
          backgroundColor: [
            '#878CFB',
            '#E41617',
          ],
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        plugins: {
          legend: {
            display: false,
          },
          labels: {
            render: 'percentage',
            fontColor: '#000',
            precision: 2
          }
        }
      },
      updatedBudgetArray: [],
      isBudgetConfigured: false,
      updatedSystemCategories: [],
      result: [],
      systemCategoryUpdate: [],
      systemColorArray: [
        { id: 0, color: 'FFFBC0', icon: 'fa fa-bus' }, 
        { id: 1, color:'FF2a9d', icon: 'fa fa-money' },
        { id: 2, color:'FF4464', icon: 'fa fa-life-bouy' },  
        { id: 3, color:'FFFFCC', icon: 'fa fa-random' }, 
        { id: 4, color: 'FFD3D3', icon: 'fa fa-database' }, 
        { id: 5, color: 'FF6FCE', icon: 'fa fa-cutlery' }, 
        { id: 6, color:'FFe9c4', icon: 'fa fa-briefcase' }, 
        { id: 7, color:'FFf4a2', icon: 'fa fa-suitcase' }, 
        { id: 8, color: 'FFe76f', icon: 'fa fa-users' },
        { id: 9, color: 'FFe639', icon: 'fa fa-home' }, 
        { id: 10, color: 'FFB081', icon: 'fa fa-shopping-bag' }, 
        { id: 11, color:'FF9c66', icon: 'fa fa-plus-square' }, 
        { id: 12, color:'FF7209', icon: 'fa fa-exchange' }, 
        { id: 13, color: 'FF4509', icon: 'fa fa-exchange' }
      ],
    }),
    computed: {
      ...mapState({
        account: state => state.dashboard.dashboardData,
        beneficiaryList: state => state.transfers.beneficiaryList,
        userBudget: state => state.budget.userBudget,
        systemCategories: state => state.budget.systemCategories,
      }),
      getBudget() {
        return this.userBudget ? this.userBudget.budget : null;
      },
      budgetCategory() {
        return this.userBudget ? this.userBudget.categories : [];
      },
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      myStyles () {
        return {
          height: `300px`,
          position: 'relative'
        };
      },
      currentDate() {
        const dateObj = new Date;
        const period = new Date(dateObj.getFullYear(), dateObj.getMonth(), 1);
        return moment(period).format('YYYY-MM-DD');
      },
      systemCategoriesWithAmount(){
        return this.systemCategories.map(category => {
          return {
            ...category,
            amount: '0.00',
            color: '',
            icon: '',
          };
        });
      },
      categoryListWithoutZero() {
        return this.budgetCategory.filter(category => {
          return category.amount !== 0;
        });
      },
    },
    mounted() {
      // var data = [{ id: 1 }, { id: 2 }];
      // const result = this.$CryptoJS.AES.encrypt(JSON.stringify(data), '1234#$%$').toString();
      // const decrypt = this.$CryptoJS.AES.decrypt(result, '1234#$%$').toString(this.$CryptoJS.enc.Utf8);
      // console.log(decrypt);
      // console.log(result);
      this.updatedBudgetArray = [];
      this.loading = true;
      this.$store.dispatch('budget/getSystemCategories');
      this.$store.dispatch('dashboard/getDashboardData').then((response) => {
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        if(response.status === 200) {
          this.loading = false;
          userParseData.accounts.forEach((account) => {
            this.isBudgetConfigured = account.isBudgetConfigured;
          });
          const dateObj = new Date();
          let firstDay = new Date(dateObj.getFullYear(), dateObj.getMonth(), 1);
          this.loaded = false;
          const data = {
            accountNumber: this.userAccounts[0].accountNumber,
            period: moment(firstDay).format('YYYY-MM-DD'),
            platform: 1,
          };
          this.$store.dispatch('budget/getUserBudget', { data }).then((response) => {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if(response.status === 204) {
              this.loading = false;
              this.budgetCategory = [];
              this.updatedBudgetArray = [];
            }
            if(response.status === 200) {
              this.loading = false;
              const budgetCategory = userParseData.categories;
              budgetCategory.forEach((category) => {
                if(category.amount !== 0) {
                  category.amount = new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2
                  }).format(category.amount);
                  this.updatedBudgetArray.push(category);
                }
              });
              this.totalAmount = userParseData.budget.amount;
              // update the system category with color and icon
              const category = this.systemCategoriesWithAmount.map((item, index) => index);
              const colorArray = this.systemColorArray.map((item, index) => index);
              category.forEach(item => {
                return colorArray.map((color, index )=> {
                  if(item === index) {
                    this.systemCategoriesWithAmount[item].color = this.systemColorArray[color].color;
                    this.systemCategoriesWithAmount[item].icon = this.systemColorArray[color].icon;
                  }
                });
              });
              this.updatedSystemCategories = this.systemCategoriesWithAmount.filter(item => {
                return !this.updatedBudgetArray.some(item2 => item2.name === item.name);
              });
              this.loaded = true;
              const data = [userParseData.budget.amount, userParseData.budget.totalExpense];
              this.data.datasets[0].data = data;
              this.form.accountNumber = userParseData.budget.accountNumber;
              this.selectedMonth = moment(userParseData.budget.budgetPeriod).format('YYYY-MM-DD');
              this.form.period = moment(userParseData.budget.budgetPeriod).format('YYYY-MM-DD');
            }
          });
        }
      });
    },
    methods : {
      addBudgetCategory() {
        $('#editModal').modal('hide');
      },
      getSelected(month){
        const monthInfo = month._d;
        let monthMoment = moment(monthInfo).format('YYYY-MM-DD');
        this.form.period = monthMoment;
        this.loaded = false;
        const data = {
          accountNumber: this.form.accountNumber,
          period: this.form.period,
          platform: 1,
        };
        this.loading = true;
        this.$store.dispatch('budget/getUserBudget', { data }).then((response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          if(response.status === 204) {
            this.loading = false;
            this.updatedBudgetArray = [];
            this.$store.commit('budget/SET_USER_BUDGET', { data: [] });
          }
          if(response.status === 200) {
            this.loading = false;
            this.loaded = true;
            const budgetCategory = userParseData.categories;
            budgetCategory.forEach((category) => {
              if(category.amount !== 0) {
                this.updatedBudgetArray.push(category);
              }
            });
            // this.updatedBudgetArray = userParseData.categories;
            const data = [userParseData.budget.amount, userParseData.budget.totalExpense];
            this.data.datasets[0].data = data;
          }
        });
      },
      getBudgetDetails(value) {
        this.budgetDetails.name = value.name;
        this.budgetDetails.amount = value.amount;
        this.budgetDetails.color = value.color;
        this.budgetDetails.category = value.category;
        this.budgetDetails.totalExpense = value.totalExpense;
        this.budgetDetails.transactions = value.transactions;
        this.budgetDetails.icon = value.icon;
      },
      async deleteBudget(id) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You want to delete your current budget?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn btn-primary',
          confirmButtonClass: 'btn btn-success mr-2',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.loading = true;
            this.$store.dispatch('budget/deleteBudget', id).then((response) => {
              if (response.status === 200) {
                this.loading = false;
                this.$swal({
                  title:'Success',
                  text: 'Budget Deleted successfully',
                  type:'success',
                  confirmButtonText: 'OK'
                }).then(() => {
                  this.$store.dispatch('budget/getUserBudget');
                  window.location.reload();
                });
              }
            }).catch((error) => {
              const decryptedError = decrypt(error.response.data);
              const objError = JSON.parse(decryptedError);
              this.loading = false;
              this.$swal({
                title:'Oops...',
                text: objError.errors[0],
                type:'error'
              });
            });
          }
        });
      },
      amountValue() {
        const test = this.updatedBudgetArray;
        const total = test.reduce((a, b) => {
          return a + Number(b.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        }, 0);
        this.totalAmount = total;
      },
      getSystemValue() {
        const filterSysCategory = this.updatedSystemCategories.filter(item => {
          return item.amount !== '0.00';
        });
        const amountTotal = this.updatedBudgetArray.reduce((a, b) => a + Number(b.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')), 0);
        const sum = filterSysCategory.reduce((a, b) => a + Number(b.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')), 0);
        this.totalAmount = amountTotal + sum;
      },
      getColor(color, index) {
        this.newBudgetCategory.color = color;
        if (this.selectedIndex.includes(index)) 
          this.removeColor(index);
        else
          this.selectedIndex = [];
        this.selectedIndex.push(index);
      },
      removeColor(index) {
        this.selectedIndex.splice(this.selectedIndex.indexOf(index),1);
      },
      addNewBudgetCategory(){
        this.generateUUID();
        const data = [];
        data.push({
          id: this.uniqueID,
          name: this.newBudgetCategory.categoryName,
          color: this.newBudgetCategory.color,
          amount: '0.00',
        });
        this.updatedSystemCategories = [...this.updatedSystemCategories, ...data];
        this.newBudgetCategory = {
          categoryName: '',
          color: '',
        };
        this.selectedIndex = [];
        $('#addCategory').modal('hide');
        $('#editModal').modal('show');
      },
      saveEditBudget() {
        const configArray = this.updatedBudgetArray;
        const filteredSystemCategory = this.updatedSystemCategories.filter((item) => {
          return item.amount !== '0.00';
        });
        const resultSystemCategory = filteredSystemCategory.map(item => {
          return {
            name: item.name,
            amount: Number(item.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
            color: item.color,
          };
        });
        const resultUpdatedBudget = configArray.map(item => {
          return {
            name: item.name,
            amount: Number(item.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
            color: item.color,
          };
        });
        this.loading = true;
        const updatedData = [...resultUpdatedBudget, ...resultSystemCategory];
        updatedData.map((item, index) => {
          if(typeof item.amount === 'string') {
            updatedData[index].amount = Number(updatedData[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
          }
        });
        const data = {
          categories: updatedData,
          shouldRollOver: true,
          platform: 1,
        };
        this.$store.dispatch('budget/updateBudget', { payload: data, id: this.getBudget.id }).then((response) => {
          if (response.status === 200) {
            $('#editModal').modal('hide');
            this.loading = false;
            this.$swal({
              title:'Success',
              text: 'Budget Updated successfully',
              type:'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.$store.dispatch('budget/getUserBudget');
              window.location.reload();
            });
          }
        }).catch((error) => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error'
          });
        });
      },
      systemFormatNum(event, id) {
        this.updatedSystemCategories.map((item, index) => {
          if(item.amount === '') {
            item.amount = '0.00';
          }
          if(item.id === id) {
            this.updatedSystemCategories[index].amount = event.target.value;
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.updatedSystemCategories[index].amount = formatter.format(this.updatedSystemCategories[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.key === 'Backspace' || event.key === 'Delete') {
              if(event.target.value.length <= 4) {
                const formatter = new Intl.NumberFormat('en-US');
                this.updatedSystemCategories[index].amount = formatter.format(this.updatedSystemCategories[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                if(event.target.value.length < 2) {
                  this.updatedSystemCategories[index].amount = '0.00';
                }
              } else {
                this.updatedSystemCategories[index].amount = event.target.value;
                const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                this.updatedSystemCategories[index].amount = formatter.format(this.updatedSystemCategories[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                return;
              }
            }
          }
        });
      },
      formatNum(event, id) {
        this.updatedBudgetArray.map((item, index) => {
          if(item.amount === '') {
            item.amount = '0.00';
          }
          if(item.id === id) {
            this.updatedBudgetArray[index].amount = event.target.value;
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.updatedBudgetArray[index].amount = formatter.format(this.updatedBudgetArray[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.key === 'Backspace' || event.key === 'Delete') {
              if(event.target.value.length <= 4) {
                const formatter = new Intl.NumberFormat('en-US');
                this.updatedBudgetArray[index].amount = formatter.format(this.updatedBudgetArray[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                if(event.target.value.length < 2) {
                  this.updatedBudgetArray[index].amount = '0.00';
                }
              } else {
                this.updatedBudgetArray[index].amount = event.target.value;
                const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                this.updatedBudgetArray[index].amount = formatter.format(this.updatedBudgetArray[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                return;
              }
            }
          }
        });
      },
      isNumber(event) {
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (d + Math.random()*16)%16 | 0;
          d = Math.floor(d/16);
          return (c==='x' ? r : (r&0x3|0x8)).toString(16);
        });
        this.uniqueID = uuid;
        return uuid;
      },
    },
  };
</script>
<style scoped>
.budget-card {
  height: 100%;
  width: 180px;
  padding: 8px 15px;
  background-color: #fff;
  border-radius: 10px;
  background: #F2F2FF;
}
.budget-card span{
  color: #878CFB;
  font-weight: 500;
  font-size: 17px;
}
.budget-card:last-child {
  background-color: #FFF4F2;
}
.budget-card:last-child span {
  color: #E41617;
}
.category-text {
  font-size: 18px;
}
.ecommerce-widget {
  border: none !important;
}
.vue-monthly-picker >>> .input {
  display: block;
  width: 100%;
  height: calc(1.6em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: none !important;
}
.ref-text {
  color: #000;
  font-size: 16px;
}
.icon-wrapper p, .live {
  font-weight: 600;
  margin-top: 10px;
  font-family: 'Open Sans', sans-serif;
}

.fa-university {
  font-size: 25px;
  /* color: #E41617; */
  background: #FFF4F2;
  width: 66px;
  padding: 20px;
  border-radius: 50px;
}
.category-amount {
  font-size: 16px;
}
.budget-card-1 {
  height: 100%;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  background: #FFF4F2;
  text-align: center;
  margin-top: 20px;
}
.total-budget-text {
  color: #E41617;
  font-size: 14px;
  font-weight: 400;
}
.total-amount-text {
  font-size: 21px;
  color: #E41617;
  font-weight: 500;
  padding-top: 10px;
}
.icon {
  font-size: 20px;
  width: 52px;
  padding: 17px;
  border-radius: 50px;
}
.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  cursor: pointer;
}
.selected {
  border: 1px solid #888888;
  box-shadow: inset 0px 0px 0px 3px white;
}
</style>